import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Alert, Button } from "antd";
import { api } from "~/lib/api.js";
import { $t } from "~/i18n.js";
import { useSelector } from "react-redux";
import { Logo } from "~/components/layout/logo.jsx";
import { ParseMessage } from "~/components/atom/parseMessage.jsx";

export const VoucherThankYou = () => {
  const { uuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [voucher, setVoucher] = useState(null);
  const persist = useSelector((state) => state.persist);

  // Extracted fetch logic for reuse
  const fetchVoucherData = async (uuid, setVoucher, setError, setLoading, isMountedRef) => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.get(`financial/prepaid-products/${uuid}/payment_thankyou.json`);
      if (isMountedRef.current) {
        setVoucher(data);
      }
    } catch (err) {
      setError(err.message || "Failed to load voucher info");
    }
    setLoading(false);
  };

  useEffect(() => {
    const isMountedRef = { current: true };
    fetchVoucherData(uuid, setVoucher, setError, setLoading, isMountedRef);
    return () => {
      isMountedRef.current = false;
    };
  }, [uuid]);
    
  if (loading)
    return <Spin style={{ display: "block", margin: "40px auto" }} />;
  if (error)
    return (
      <Alert
        type="error"
        message={error}
        style={{ maxWidth: 500, margin: "40px auto" }}
      />
    );

  return (
    <div
      style={{
        maxWidth: 500,
        margin: "40px auto",
        padding: 24,
        background: "#fff",
        borderRadius: 8,
      }}
    >
      <div style={{gap: 6, alignContent: "flex-start", marginBottom: 18}}>
        <Logo url={persist?.club?.logo} width={80} height={30} />

        {voucher && voucher.payment_status === 'open' && (
          <div style={{margin: '24px 0'}}>
            <Alert
              type="warning"
              message={$t('Wachten op betaling')}
              description={
                <>
                  <div>{$t('Je betaling (lijkt) nog niet binnen te zijn.')}</div>
                  <div style={{marginTop: 12}}>
                    <Button type="primary" onClick={() => fetchVoucherData(uuid, setVoucher, setError, setLoading, { current: true })}>
                      {$t('Check betaling')}
                    </Button>
                  </div>
                </>
              }
              showIcon
            />
          </div>
        )}

        {voucher && (voucher.payment_status === 'failed' || voucher.payment_status === 'expired') && (
          <div style={{margin: '24px 0'}}>
            <Alert
              type="error"
              message={$t('Betaling mislukt')}
              description={
                <>
                  <div>{$t('Probeer opnieuw')}</div>
                  <div style={{marginTop: 12}}>
                    <Button type="primary" href={`/voucher/${voucher.slug}`}>
                      {$t('Opnieuw proberen')}
                    </Button>
                  </div>
                </>
              }
              showIcon
            />
          </div>
        )}

        {voucher && voucher.payment_status === 'paid' && (
          <section>
            <h1>{$t("Bedankt voor je bestelling")}</h1>
            <div style={{margin: '24px 0'}}>
              <ParseMessage message={voucher.thank_you} />
            </div>

            <p>{$t('Je hebt een email ontvangen en kan dit scherm sluiten.')}</p>
          </section>
        )}
      </div>
    </div>
  );
}
